// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fab-create-user {\n  margin-top: -14px !important;\n  margin-right: 10px;\n}\n.main-card .header-animate {\n  -webkit-transition: padding 150ms ease-in !important;\n  transition: padding 150ms ease-in !important;\n}", ""]);
// Exports
module.exports = exports;
